import { html, View } from 'rune-ts';
import { Typo } from '../Typo/Typo';
import klass from './Button.module.scss';

export interface ButtonData {
  label: Typo;
}

export interface ButtonOption {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'disabled' | 'line';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  klass?: string;
}

const SIZE = {
  x_small: klass.x_small,
  small: klass.small,
  medium: klass.medium,
  large: klass.large,
};

const COLOR = {
  primary: klass.primary,
  secondary: klass.secondary,
  disabled: klass.disabled,
  line: klass.line,
};

type ButtonType<T> = {
  [K in keyof T]: string;
};

export class Button extends View<ButtonData> {
  static size: ButtonType<typeof SIZE> = SIZE;
  static color: ButtonType<typeof COLOR> = COLOR;

  constructor(
    data: ButtonData,
    public option: ButtonOption = { size: 'large', disabled: false, type: 'submit' },
  ) {
    super({
      ...data,
    });
  }

  private makeKlass() {
    const { size, color, disabled } = this.option;

    const klasses = [
      Button.size[size ?? 'small'] ?? klass.small,
      disabled ? Button.color.disabled : color ? Button.color[color] ?? Button.color.primary : Button.color.primary,
      this.option.klass,
    ];

    return html`${klasses.filter(Boolean).join(' ')}`;
  }

  override template() {
    return html`<button
      ${this.option.type ? html`type="${this.option.type}"` : ''}
      class="${klass.button} ${this.makeKlass()}"
      ${this.option.disabled ? 'disabled' : ''}
    >
      ${this.data.label}
    </button>`;
  }

  disabled() {
    this.option.disabled = true;
    this.redraw();
  }

  enabled() {
    this.option.disabled = false;
    this.redraw();
  }
}
